export default __webpack_public_path__ + "static/media/Sending_accessibility_feedback.b3388380.svg";